<template>
  <div>
    <div class="text-h6">{{ data.campaign_name }}</div>
    <div
      v-if="data.campaign_id == 0"
      class="items-center row rounded-borders text-weight-bold q-py-md q-px-sm text-white bg-purple-5"
    >
      <q-icon name="warning" class="col-1" style="font-size: 28px" />
      <p class="text-sm col-11">
        {{ $t('attention_message_postback') }}
      </p>
    </div>
    <q-separator spaced />
    <q-input
      v-model="params.url"
      outlined
      type="url"
      dense
      label="URL para direcionamento de volta"
      lazy-rules
      :rules="[isRequired, validURL]"
      error-message="Informe uma URL válida"
    />
    <q-separator spaced="lg" />
    <q-card flat bordered>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title class="text-body1"> {{ $t('additional_parameters') }} </q-toolbar-title>
        <q-btn color="positive" icon="mdi-plus" unelevated @click="addParameters">
          <q-tooltip> {{ $t('add_parameter') }} </q-tooltip>
        </q-btn>
      </q-toolbar>
      <q-card-section class="row q-col-gutter-md">
        <div class="col-6">{{ $t('parameters') }}</div>
        <div class="col-6">{{ $t('value') }}</div>
      </q-card-section>

      <q-card-section class="row q-col-gutter-md q-pt-xs" v-for="(item, index) in additionalParameters" :key="index">
        <div class="col-6">
          <q-input v-model="item.param_name" type="text" dense :label="$t('parameter_name')" outlined>
            <!-- <template v-slot:after>
              <q-btn unelevated color="negative" icon="mdi-close" @click="removeParameters(index)" />
            </template> -->
          </q-input>
        </div>
        <div class="col-6" style="display: flex; align-items: center">
          <q-select
            v-model="item.param"
            outlined
            dense
            :options="paramsAll"
            option-label="param_indice_name"
            option-value="id"
            :label="$t('variable')"
            style="flex: 1; margin-right: 5px"
          />
          <q-btn unelevated color="negative" icon="mdi-close" @click="removeParameters(index)" />
        </div>
      </q-card-section>
    </q-card>
    <q-separator spaced="lg" />
    <q-card flat bordered>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title class="text-body1"> {{ $t('custom_parameters') }} </q-toolbar-title>
        <q-btn color="positive" icon="mdi-plus" unelevated @click="addCustomParameters">
          <q-tooltip> {{ $t('add_parameter') }} </q-tooltip>
        </q-btn>
      </q-toolbar>
      <q-card-section class="row q-col-gutter-md">
        <div class="col-6">{{ $t('parameters') }}</div>
        <div class="col-6">{{ $t('value') }}</div>
      </q-card-section>

      <q-card-section class="row q-col-gutter-md q-pt-xs" v-for="(item, index) in customParameters" :key="index">
        <div class="col-6">
          <q-input v-model="item.param_name" outlined dense type="text" :label="$t('parameter_name')" />
        </div>
        <div class="col-6">
          <q-input v-model="item.param_custom_value" type="text" dense :label="$t('variable')" outlined>
            <template v-slot:after>
              <q-btn unelevated color="negative" icon="mdi-close" @click="removeCustomParameters(index)" />
            </template>
          </q-input>
        </div>
      </q-card-section>
    </q-card>
    <q-separator spaced="lg" />
    <q-card flat bordered>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title class="text-body1"> {{ $t('basic_auth') }} </q-toolbar-title>
        <q-toggle color="positive" unelevated v-model="basicAuth"> </q-toggle>
      </q-toolbar>

      <q-card-section
        v-show="basicAuth"
        class="row q-col-gutter-md"
        transition-show="slide-up"
        transition-hide="slide-down"
      >
        <div class="col-6">
          <q-input v-model="auth.login" outlined dense type="text" :label="$t('auth_login')" />
        </div>
        <div class="col-6">
          <q-input v-model="auth.password" outlined dense :label="$t('password')" :type="isPwd ? 'password' : 'text'">
            <template v-slot:append>
              <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer" @click="isPwd = !isPwd" />
            </template>
          </q-input>
        </div>
      </q-card-section>
    </q-card>
    <q-separator spaced="lg" />
    <span class="text-body2">{{ $t('final_url') }}</span>
    <q-banner inline-actions class="bg-purple text-white" rounded>
      {{ finalURL }}
      <template v-slot:action>
        <q-btn no-caps unelevated outlined icon="mdi-content-copy" @click="copyData(finalURL)">
          <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px"> {{ $t('copy') }} </q-tooltip>
        </q-btn>
      </template>
    </q-banner>
  </div>
</template>

<script>
import { copyToClipboard } from 'quasar';

export default {
  name: 'PostBackParams',
  data() {
    return {
      isPwd: true,
      auth: {
        password: '',
        login: ''
      },
      paramsAll: [],
      additionalParameters: [],
      customParameters: [],
      basicAuth: false
    };
  },
  props: {
    data: Object,
    params: {
      type: Object,
      default: () => ({
        param_name: null,
        param_indice_id: null,
        param_indice_name: null
      })
    },
    channelId: [Number, String]
  },
  computed: {
    finalURL() {
      if (this.params.url) {
        let queryParams = '';
        if (this.additionalParameters.length > 0) {
          this.additionalParameters.forEach((element, index) => {
            if (element.param_name) {
              queryParams += `${element.param_name}={${this.convertToSnakeCase(element.param.param_indice_name)}}`;
              if (index !== this.additionalParameters.length - 1) queryParams += '&';
            }
          });
        }
        if (this.customParameters.length > 0) {
          if (queryParams !== '') queryParams += '&';
          this.customParameters.forEach((element, index) => {
            if (element.param_name && element.param_custom_value) {
              queryParams += element.param_name + '=' + element.param_custom_value;
              if (index !== this.customParameters.length - 1) queryParams += '&';
            }
          });
        }

        if (this.params.url.includes('?')) {
          return this.params.url + '&' + queryParams;
        }

        return this.params.url + '?' + queryParams;
      }
      return '';
    }
  },
  methods: {
    reset() {
      this.params.url = '';
      this.additionalParameters = [];
      this.customParameters = [];
    },

    addCustomParameters() {
      this.customParameters.push({
        param: null,
        value: null
      });
    },
    copyData(value) {
      copyToClipboard(value)
        .then(() => {
          this.successNotify(this.$t('url_copied'));
        })
        .catch(() => {
          this.errorNotify(this.$t('error_copying_url'));
        });
    },
    convertToSnakeCase(string) {
      if (!string) return '';
      return string
        .replace(/\W+/g, ' ')
        .split(/ |\B(?=[A-Z])/)
        .map((word) => word.toLowerCase())
        .join('_');
    },
    addParameters() {
      this.additionalParameters.push({
        param: {
          id: null,
          param_indice_name: null
        },
        param_name: null
      });
    },
    removeParameters(index) {
      this.additionalParameters.splice(index, 1);
    },
    removeCustomParameters(index) {
      this.customParameters.splice(index, 1);
    },
    async getParameters() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/redirect?app=conversorphp&path=%2Fapi%2Fpostback%2Fparams%2Findices'
        );
        if (status === 200) this.paramsAll = data;
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },
    base64ToUtf8(string) {
      return decodeURIComponent(escape(window.atob(string)));
    },
    setParamValues() {
      if (this.params.params) {
        this.additionalParameters = this.params.params.map((item) => ({
          param: {
            id: item.param_indice_id,
            param_indice_name: item.param_indice_name
          },
          param_name: item.param_name
        }));
      }

      if (this.params.custom_params !== undefined) {
        this.customParameters = this.params.custom_params;
      } else {
        this.customParameters = [];
      }
      if (this.params.auth !== undefined) {
        this.auth = {
          ...this.params.auth,
          password: this.base64ToUtf8(this.params.auth.password)
        };

        this.basicAuth = true;
      } else {
        this.auth = {};
        this.basicAuth = false;
      }
    }
  },
  created() {
    this.getParameters();
    this.setParamValues();
  },

  watch: {
    params() {
      this.setParamValues();
    },

    auth: {
      handler(val) {
        this.$emit('updateAuth', val, this.basicAuth);
      },
      deep: true
    },

    basicAuth() {
      this.$emit('updateAuth', this.auth, this.basicAuth);
    }
  }
};
</script>

<style></style>
